<template>
    <div class="root">
        <div class="modal criticalmodal" v-if=" showDoubleBarcode" style="z-index: 1000;">
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 1 }" v-if="modalid == 1">
                <div class="modal-content">
                    <table style="font-size: 30pt">
                        <td>
                            Der Barcode <span class="barcodespan">{{ tmpbarcode }}</span> wurde bereits eingescannt.<br/><br/>
                            <b>Position:</b> {{ tmpposdata.fpos }}
                        </td>
                    </table>
                </div>
            </div>
            </transition>
        </div>

        <div class="modal" v-if="tmptext" style="z-index: 1000;">
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 1 }" v-if="modalid == 1">
                <div class="modal-content">
                    <table style="font-size: 30pt">
                        <tr>
                            <td><b>Barcode:</b></td>
                            <td>{{ tmptext.barcode }}</td>
                        </tr>
                        <tr>
                            <td><b>Position:</b></td>
                            <td>{{ tmptext.fpos }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            </transition>
        </div>


        <div class="modal" v-if="showmodal">
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 1, 'hidden': modalid !== 1 }" v-if="modalid == 1">
                <div class="modal-title">
                    {{ translation.BRANDING }}
                </div>
                <div class="modal-content">
                    {{ translation.STR_WELLS_INSERTED }}
                </div>
                <div class="buttons">
                    <div class="btn-yes" v-on:click="startTest2">{{ translation.STR_YES }}</div>
                    <div class="btn-no" v-on:click="restartApp">{{ translation.STR_NO }}</div>
                </div>
            </div>
            </transition>
            <transition name="fade">
            <div class="modal-window visible" :class="{ 'visible' : modalid == 2, 'hidden': modalid !== 2 }" v-if="modalid == 2">
                <div class="modal-title">
                    {{ translation.BRANDING }}
                </div>
                <div class="modal-content">
                    {{ translation.STR_LID_CLOSED }}
                </div>
                <div class="buttons">
                    <div class="btn-yes" v-on:click="startRealTest">{{ translation.STR_YES }}</div>
                    <div class="btn-no" v-on:click="restartApp">{{ translation.STR_NO }}</div>
                </div>
            </div>
            </transition>

        </div>
            </transition>

        <section>
            <h1>{{ translation.STR_PLEASE_SCAN_SAMPLES }}</h1>
        </section>


        <section class="wells">
            <div>
                <b>{{ translation.STR_SAMPLE_POSITIONS}}</b>
                <table>
                    <tr v-for="r in wellsdat.rows">
                        <td v-for="w in r.wells">
                            <div v-on:click="ShowSpecificPosition(w)" class="dot" :class=" { 'inuse' : w.barcode, 'avail' : !w.barcode, 'expressprobe': w.express }">
                                <span><center>{{ w.fpos }}<br/><span v-if="w.express" style="font-size: 9pt">Express</span></center></span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
        <section class="scanner">
            <table style="margin: auto:">
                <tr>
                    <td colspan="2"><span v-if=" tmpcode"><b>Letzer Barcode: </b><b style="font: 12pt 'Courier New';">{{ tmpcode }}</b></span>&nbsp;</td>
                </tr>
                <tr>
                    <td v-if="hasAvailWells">
                        <input type="text" :disabled="!hasAvailWells" class="barcode" v-on:keyup.enter="AddBarcode" v-model="barcode" :placeHolder="translation.STR_BARCODE" ref="barcodescanner" autofocus />
                    </td>
                    <td v-if="!hasAvailWells">
                        <div class="error">
                        Es stehen keine weiteren Positionen zur Verfügung.
                        </div>    
                    </td>
                    <td width="200">
                        <input type="button" v-on:click="startTest" :disabled="!usedWells" :class="{ 'disabledbtn' :!usedWells }" :value="translation.STR_START" />
                    </td>
                    <td v-if="ScreeningPortalEnabled && hasAvailWells">
                        <div class="express-probe" :class="{ 'expresson':epxressprobeenabled, 'expressoff': !epxressprobeenabled }" v-on:click="epxressprobeenabled=!epxressprobeenabled">
                            Express: <b>{{ epxressprobeenabled ? "EIN" : "AUS" }}</b>
                        </div>
                    </td>
                </tr>
            </table>
            
            
        </section>
    </div>
</template>
<script>
var timer_tmpcode = null;
export default ({
    props: [ 'translation', 'ScreeningPortalEnabled'],
    mounted() {
        this.CalcWells();
        this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=openlid").catch(() => {
            this.$emit('triggererror', 'Opening Lid did not work.')
        })
        setInterval(() => {
            this.$refs.barcodescanner.focus();
        }, 500);
    },
    computed: {
        usedWells() {
            var usedwells = 0;
            if(!this.wellsdat.rows) return false;
            this.wellsdat.rows.forEach((r) => {
                usedwells+= r.wells.filter(e => e.barcode === null).length;
            })
            return this.wells-usedwells;
        },
        hasAvailWells() {
            var hasavail = 0;
            if(!this.wellsdat.rows) return false;
            this.wellsdat.rows.forEach((r) => {
                hasavail = r.wells.filter(e => e.barcode === null).length > 0;
            })
            return hasavail;
        }
    },
    methods: { 
        ShowSpecificPosition(i) {
            if(i.barcode.trim() !== "") {
                this.tmptext = i;
                setTimeout(() => {
                    this.tmptext = null;
                }, 3000)
            }
        },
        getFriendlyPosition(p) {
            var pos = p.id;
            if(p.row == 2) pos = pos-(this.wells/this.wellrows);
            if(pos < 10) pos="0"+pos;
            return pos;
        },
        getRowFriendlyName(a) {
            if(a == 1) return "A";
            if(a == 2) return "B";
            if(a == 3) return "C";
            if(a == 4) return "D";
            if(a == 5) return "E";
            if(a == 6) return "F";
            if(a == 7) return "G";
            if(a == 8) return "H";
            if(a == 9) return "I";
            if(a == 10) return "J";
            if(a == 11) return "K";
        },
        startTest() {
            this.showmodal = true;
        },
        restartApp() {
            this.showmodal = false;
            this.modalid = 1;
        },
        startTest2() {
            this.modalid = 2;
        },
        startRealTest() {
            this.$router.push({
                name: 'StartTest',
                params: {
                    test: this.$route.params.testType,
                    wells: this.wellsdat,
                }
            })
        },
        CalcWells() {
            var wells = [];
            var rows = this.wells / this.wellrows;
            var row = 1;
            var drows = [];
            for (let i = 0; i < this.wells; i++) {
                var id = (i+1);
                if(i == this.wells/this.wellrows) row++;
                
                var idn = id < 10 ? "0"+id : id;
                var xrow = row;
                if(row == 2) xrow = id-(8); else xrow=row;

                wells.push({
                    id: id,
                    row: row,
                    barcode: null,
                    fpos: this.getRowFriendlyName(row)+this.getFriendlyPosition({ id: (id-(8*(row-1))) }),
                    express: false,
                })
            }
            for (let i = 1; i < this.wellrows+1; i++) {
                drows.push({
                    row: i,
                    wells: wells.filter(e => e.row == i),
                });
            }
            this.wellsdat = {
                totalrows: this.wellrows,
                rows: drows,
            };
            return wells;
        },
        AddBarcode() {
            var nextpos = null;
            if(timer_tmpcode) clearInterval(timer_tmpcode);
            this.tmpcode = null;
            this.tmpbarcode = this.barcode;

            // 10 stellige barcodes only::
            // if(this.tmpbarcode.length !== 10) return false;


            this.wellsdat.rows.forEach((r) => {
                var tnextpos = r.wells.find(e => e.barcode === null);
                if(tnextpos && nextpos == null) {
                    nextpos = tnextpos;
                }
            })

            var block = false;
            this.wellsdat.rows.forEach((i) => {
                var tt = i.wells.find(e => e.barcode !== null && e.barcode == this.barcode);
                if(tt) {
                    this.barcode = null;
                    this.showDoubleBarcode = true;
                    this.tmpposdata = tt;
                    setTimeout(() => {
                        this.showDoubleBarcode = false;
                    }, 3000)
                    block = true;
                }
            })

            if(nextpos && !block) {
                nextpos.barcode = this.barcode;
                nextpos.express = this.epxressprobeenabled;
                this.barcode = null;
                this.tmpcode = nextpos.barcode;
                timer_tmpcode = setTimeout(() => {
                    this.tmpcode = null;
                }, 1000)
            } else {
                this.noMoreWells = true;
            }
        }
    },
    data() { 
        return {
            epxressprobeenabled: false,
            tmpposdata: null,
            tmpbarcode: null,
            showDoubleBarcode: false,
            tmptext: null,
            noMoreWells: false,
            tmpcode: null,
            showmodal: false,
            modalid: 1,
            wellsdat: false,
            barcode: null,
            poscounter: 0,
            wellrows: 2,
            wells: 16,
        } 
    }
})
</script>
<style scoped>
.root {
    height: 100%;
    width: 100%;
    overflow: hidden !important;
}
table {
    width: 500px;
    margin: auto;
}
.wells {
    height: 480px;
    display: flex;
    justify-content: center;
    align-content: center;
}
.wells div {
    margin: auto;
}
.scanner {
    height: 120px;
    width: 100%;
    display: flex;
}
.scanner input[type="text"] {
    padding: 25px;
    width: 500px;
    border: 1px solid var(--primary-color);
    border-radius: 0px;
    margin: auto;
}

.scanner input[type="button"] {
    padding: 25px;
    width: 150px;
    border: 1px solid var(--primary-color);
    border-radius: 0px;
    margin: auto;
    cursor: pointer;
    background-color: var(--primary-color);
    color: var(--secondary-color);
}


.scanner input:focus {
    outline: none;
}

.avail {
    background-color: lightgreen !important;
}
.inuse {
    background-color: var(--primary-color) !important;
    color: var(--secondary-color);
}

.dot {
  height: 80px;
  width: 80px;
  background-color: #bbb;
  border-radius: 50%;
  display: flex;
  justify-content: center;
}
.dot span {
    margin: auto;
}
.disabledbtn {
    background-color: gray !important;
    color: silver !important;
}
.criticalmodal {
    background-color: black !important;
    background-size: cover;
    color: #fff;

    -webkit-animation: AnimationName 0s ease infinite;
    -moz-animation: AnimationName 0s ease infinite;
    animation: AnimationName 0s ease infinite;

}
.criticalmodal .modal-content {
    background-color: black;
}
.modal {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    background-color: var(--primary-color);
    display: flex;
}
.modal-window {
    position: absolute;
    min-width: 400px;
    margin: auto;
    border: 1px solid var(--secondary-color);
    background-color: var(--secondary-color);


    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.modal-title {
    padding: 15px;
    font-weight: bold;
    border-bottom: 2px solid var(--primary-color);
}
.modal-content {
    padding: 15px;
}
.modal .buttons {
    padding: 15px;
    display: flex;
    text-align: center;
    align-items: center;
    width: 320px;
    margin: auto;
}
.btn-yes {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    padding: 15px;
    width: 150px;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
}
.btn-no {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    padding: 15px;
    width: 150px;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
}

.tmpcode {
    font: 10pt "courier new";
    position: absolute;
    bottom: 280px;
    font-size: 18pt;
    font-weight: bold;
    background-color: lightblue;
    padding: 15px;
    width: 200px;
    margin: auto;
}

.error {
    background-color: pink;
    font-size: 13pt;;
    padding: 15px;
}

.barcodespan {
    background-color: black;
    color: #fff;
    padding-left: 5px;
    padding-right: 5px;
    font-face: 'Courier New';
}



@-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
}
@keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 51%}
    100%{background-position:0% 50%}
}

.express-probe {
    top: 10px;
    left: calc(100% - 180px);
    padding: 10px;
    width: 120px;
    cursor: pointer;
    box-sizing: border-box;
}
.expressprobe {
    background-color: gold !important;
    color: black;
}
.expresson {
    background-color: lightgreen;
}
.expressoff {
    background-color: red;
}
</style>